var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"tooltip",attrs:{"tabindex":"0","role":"tooltip"}},[_c('i',{staticClass:"icon-info-fill",attrs:{"aria-hidden":"true"}}),_c('span',{staticClass:"tooltip__content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }